import { del, get, post, put } from '@/utils/request'
interface globalList {
  code: string
  name: string
  description?: string
}

interface globalListDetail {
  globalListId: number
  value: number
  code: string
  name: string
  description?: string
}

export function getGlobalList<T = any>(data: any) {
  return get<T>({
    url: '/users-service/global_list',
    data,
  })
}
export function createGlobalList<T = any>(
  data: globalList,
) {
  return post<T>({
    url: '/users-service/global_list/global_list/create',
    data,
  })
}

export function updateGlobalList<T = any>(id: number, data: any) {
  return put<T>({
    url: `/users-service/global_list/update?id=${id}`,
    data,
  })
}

export function deleteGlobalList<T = any>(id: number) {
  return del<T>({
    url: `/users-service/global_list/delete?id=${id}`,
  })
}

export function createGlobalListDetail<T = any>(
  data: globalListDetail,
) {
  return post<T>({
    url: '/users-service/global_list_detail/global_list/create',
    data,
  })
}

export function getGlobalListDetail<T = any>(data: any) {
  return post<T>({
    url: '/users-service/global_list_detail',
    data,
  })
}

export function updateGlobalListDetail<T = any>(id: number, data: globalList) {
  return put<T>({
    url: `/users-service/global_list_detail/update?id=${id}`,
    data,
  })
}

export function deleteGlobalListDetail<T = any>(id: number) {
  return del<T>({
    url: `/users-service/global_list_detail/delete?id=${id}`,
  })
}
